import { useState, useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import { getFirebaseToken, onMessageListener } from "../../FirebaseConfig";

function Notification() {
  // To store notification data from firebase
  const [notification, setNotification] = useState<{
    title: string;
    body: string;
  }>({ title: "", body: "" });

  const handleGetFirebaseToken = () => {
    getFirebaseToken()
      .then((firebaseToken: string | undefined) => {
        if (firebaseToken) {
          localStorage.setItem("device_token", firebaseToken);
        }
      })
      .catch(() => {
        // Push may be unavailable in local/dev browsers
      });
  };

  // Need this handle FCM token generation when a user manually blocks or allows notification
  useEffect(() => {
    if (!("Notification" in window)) return;

    let cancelled = false;
    window.Notification.requestPermission()
      .then((permission) => {
        if (cancelled || permission !== "granted") return;
        handleGetFirebaseToken();
        onMessageListener()
          .then((payload: any) => {
            if (cancelled || !payload) return;
            setNotification({
              title: payload?.notification?.title,
              body: payload?.notification?.body,
            });
            toast.success(
              `${payload?.notification?.title}, ${payload?.notification?.body}`,
              {
                duration: 60000,
                style: {
                  border: "1px solid #1EC677",
                  padding: "10px 25px",
                  color: "#1EC677",
                },
                iconTheme: {
                  primary: "#1EC677",
                  secondary: "#00190D",
                },
              }
            );
          })
          .catch(() => {
            // Ignore push listener failures in local/dev
          });
      })
      .catch(() => {
        // Ignore permission / push failures
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <Toaster />
    </div>
  );
}

export default Notification;
